module.exports = __webpack_public_path__ + "static/q4-46a33b91faba3b66395dbf274106be9d.svg";